export const locales = ["All", "City", "Suburb", "Town", "Rural"];
export const demographics = {
  Everyone: ["Everyone"],
  Age: ["Middle School", "High School"],
  Gender: ["Female", { value: "Trans", label: "Trans/NB" }, "Male"],
  Race: ["Black", "Hispanic", "Mixed Race", "White"],
};
